import SyntheseEntityResultController from './syntheseentities.result.controller';

export default {
    template: require('./syntheseentities.result.html'),
    controller: SyntheseEntityResultController
};
